import { Component, OnInit } from '@angular/core';
import {FormsModel, StaticMethods} from '../../../model/GeneralModels';
import {ActivatedRoute, Router} from '@angular/router';
import {GeneralService} from '../../../services/general.service';

@Component({
  selector: 'app-basic-information',
  templateUrl: './basic-information.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css',
  ],
})
export class BasicInformationComponent implements OnInit {
  productName = 'HEALTH_GROUP';
  forms: FormsModel[] = [];
  viewList: any = {};
  translation: any = {};

  constructor(private activatedRoute: ActivatedRoute,
              private generalService: GeneralService,
              private router: Router) { }
  ngOnInit(): void {
    this.generalService.getBasicInformationQuestions(this.productName, 0).subscribe(response => {
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        this.forms.push(new FormsModel(response.data, null));
      }
    });
  }

  goNext() {
    if (this.forms[0].formGroup.valid) {
      console.log(this.forms[0].formGroup.value);
      console.log(this.viewList);
      this.router.navigate([`/${this.productName}/offers`],
        {
          state: {
            viewList: this.viewList,
            formsData: this.forms[0].formGroup.value,
            translation: this.translation
          }
        });
    } else {
      console.log(this.forms[0].formGroup);
    }
  }
}
